









































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import StatementModule from '@/store/modules/Statement';
import CurrencyModule from '@/store/modules/Currency';
import AuthModule from '@/store/modules/Auth';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Statement from '@/components/Statement.vue';
import DepositWithdrawBody from '@/components/Table/DepositWithdrawBody.vue';
import Pagination from '@/components/Pagination.vue';
import DepositWithdrawData from '@/data/DepositWithdrawData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    Statement,
    Pagination,
    DepositWithdrawBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin,
  ErrorHandleMixin,
  PaginationMixin,
) {
  StatementInstance = getModule(StatementModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  CurrencyInstance = getModule(CurrencyModule, this.$store);

  Criteria: any = {
    ...this.Period,
    role: this.AuthInstance.user.role,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    isSearch: false,
  };

  BreadcrumbList: any = [];

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  startCount = 1;

  StatementList: any = {};

  modal = false;

  dataList: any = [];

  LoginName = '';

  TableHead = DepositWithdrawData.TableHead;

  statementCriteria = {
    username: '',
    role: '',
    isMultiCurrency: true,
  };

  sum = {
    totalCreditDeposit: 0,
    totalCreditWithdraw: 0,
    creditBalance: 0,
    totalAutoDeposit: 0,
    totalAutoWithdraw: 0,
    autoBalance: 0,
  };

  statement: any[] = [];

  currencyRate = {};

  multiCurrency = [];

  toggleMode = false;

  startDate = '';

  endDate = '';

  totalCurrency: any = [];

  activeCurrency = 'All'

  currencyList: string[] = [];

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  };

  created() {
    this.initial();
    this.fetchStatement();
  }

  setCurrency(item) {
    this.activeCurrency = item;
    this.currencyList = item === 'All' ? [...this.totalCurrency] : [item];
  }

  initial() {
    this.Criteria = {
      ...this.Period,
      role: this.AuthInstance.user.role,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      isSearch: false,
      isFirstAgent: false,
      isMultiCurrency: true,
    };
    this.LoginName = '';
  }

  submit() {
    this.PaginationDetail.current = 1;
    this.fetchStatement();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    this.startDate = this.$moment(this.Period.start.date)
      .startOf('day')
      .toDate();
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    this.endDate = this.$moment(this.Period.end.date)
      .endOf('day')
      .toDate();
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.PaginationDetail.current = 1;
    this.fetchStatement();
  }

  async fetchStatement() {
    this.statement = [];
    const totalCC = await this.CurrencyInstance.fetchCurrencyRate({
      data: { currency: '' },
    });
    this.currencyRate = totalCC.rateCurrency;
    this.multiCurrency = totalCC.currency;
    const criteria = {
      ...this.Criteria,
      ...this.Period,
      ...this.PaginationDetail,
    };
    this.GeneralInstance.toggleLoading(true);
    const { status } = await this.StatementInstance.FetchStatement(criteria);
    this.checkError(status);
    this.StatementList = this.StatementInstance.dataStatement;
    const dataCurrency = this.StatementList.statementLogs
      .map((items) => items.currency);
    this.totalCurrency = [...new Set(dataCurrency)];
    this.currencyList = [...this.totalCurrency];
    this.statement.sort((a: any, b: any) => b.data.length - a.data.length);
    this.BreadcrumbList = [
      ...this.BreadcrumbDefault,
      ...this.StatementInstance.dataStatement.breadcrumb,
    ];
    this.startCount = this.StatementList.pagination.startCount
      ? this.StatementList.pagination.startCount
      : 1;
    this.PaginationDetail.amount = this.StatementList.pagination.pageAmount;
    this.GeneralInstance.toggleLoading(false);
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchStatement();
  }

  switchFullmode() {
    this.PaginationDetail.current = 1;
    this.Criteria.isMultiCurrency = !this.Criteria.isMultiCurrency;
    this.fetchStatement();
  }

  openDetail(username, role) {
    this.modal = true;
    this.statementCriteria = {
      username,
      role,
      isMultiCurrency: this.Criteria.isMultiCurrency,
    };
  }

  onSubmit() {
    this.fetchStatement();
  }

  onReset() {
    this.initial();
    this.fetchStatement();
  }

  handleSearch() {
    this.Criteria.isSearch = !!this.LoginName;
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
  }

  handleFetcDepositWithdraw(username, role, source) {
    this.beforeFetch(username, role, source);
    this.fetchStatement();
  }

  handleBreadcrumb({ username, role, source }) {
    this.beforeFetch(username, role, source);
    this.fetchStatement();
  }

  beforeFetch(username, role, source) {
    this.Criteria.username = username;
    this.Criteria.role = role;
    this.Criteria.source = source;
    this.Criteria.isSearch = false;
    this.LoginName = '';
  }
}
